import { inject, Injectable } from '@angular/core';
import { AuthenticationService } from '../../service/admin-console/authentication/authentication.service';
import { EnvironmentService } from '../../shared/service/environment.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly environmentService = inject(EnvironmentService);

  private readonly environment = this.environmentService.getPrivilegeEnv();
  private userPrivileges: string[] = [];

  constructor() {
    this.authenticationService.sessionData$.subscribe(data => {
      this.userPrivileges = data?.privileges ?? [];
    });
  }

  checkPrivileges(
    requiredPrivileges: { test: string[]; prod: string[] } | null | undefined
  ): boolean {
    if (!requiredPrivileges) {
      return true;
    }

    const privilegesForEnv = requiredPrivileges[this.environment];
    if (!privilegesForEnv || privilegesForEnv.length === 0) {
      return true;
    }

    if (!this.userPrivileges) {
      return false;
    }

    const userHasAnyRequiredPrivilege = privilegesForEnv.some(privilege =>
      this.userPrivileges.includes(privilege)
    );

    return userHasAnyRequiredPrivilege;
  }
}
